export const OPTION_RESULT = [
    'Rối loạn phát triển trí tuệ',
    'Rối loạn nhận thức thần kinh',
    'Rối loạn học tập biệt định và rối loạn giao tiếp',
    'Rối loạn giao tiếp',
    'Rối loạn ngôn ngữ',
    'Biến thể bình thường của ngôn ngữ',
    'Khiếm thính hoặc suy giảm các giác quan khác',
    'Rối loạn thần kinh',
    'Ngôn ngữ thoái triển',
    'Rối loạn phát âm',
    'Chứng khó đọc',
    'Câm chọn lọc',
    'Khuyết tật cấu trúc (sứt môi, chẻ vòm)',
    'Rối loạn lưu loát ở trẻ',
    'Rối loạn giao tiếp xã hội',
    'Rối loạn lo âu xã hội',
    'Rối loạn phổ tự kỷ',
    'Hội chứng Rett',
    'Rối loạn vận động rập khuôn/ định hình',
    'OCD và các rối loạn liên quan',
    'Rối loạn Tic',
    'Rối loạn tic nhất thời',
    'Rối loạn tic vận động và lời nói mạn tính',
    'Tâm thần phân liệt',
    'Rối loạn tăng động giảm chú ý ',
    'Rối loạn tăng động giảm chú ý kết hợp',
    'Giảm chú ý biểu hiện ưu thế',
    'Tăng động biểu hiện ưu thế',
    'Rối loạn thách thức chống đối',
    'Rối loạn bùng phát gián đoạn',
    'Rối loạn học tập biệt định',
    'Rối loạn phản ứng gắn bó',
    'Rối loạn lo âu',
    'Rối loạn trầm cảm',
    'Rối loạn lưỡng cực',
    'Rối loạn điều hòa khí sắc',
    'Rối loạn nhân cách',
    'Thuốc gây ra rối loạn tăng động giảm chú ý',
    'Rối loạn nhận thức thần kinh',
    'Rối loạn học tập biệt định',
    'Học tập khó khăn do rối loạn giác quan và thần kinh',
    'Rối loạn phối hợp phát triển',
    'Rối loạn điều hòa phát triển',
    'Theo dõi nguy cơ rối loạn phổ tự kỷ',
    'Theo dõi nguy cơ tăng động giảm chú ý',
    'Chậm nói',
    'Rối loạn âm lời nói',
    'Chậm phát triển',
    'Chậm vận động',
    'Chậm phát triển tâm thần vận động',
    'Tổn thương não',
    'Tăng trương lực cơ',
    'Giảm trương lực cơ',
    'Khiếm thính',
    'Hở hàm ếch',
    'Động kinh',
    'Khó khăn học tập',
    'Khó khăn đọc viết',
    'Chứng khó đọc',
    'Táo bón',
    'Rối loạn giấc ngủ',
    'Khó khăn ăn uống',
    'Hội chứng Down'
]